/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPPRODUCTCONFIGURATIONCODE = {
    AlexanderForbesConsolidator: 'GAFDSP01',
    DiscretionaryIncomePlan: 'GAFDSP02',
    AlexanderForbesLiquidity: 'GAFDSP03',
    PersonalisedPortfolioPlan: 'GAFDSP04',
    WealthCreatorEndowmentPolicy: 'GAFEND01',
    TheAlexanderForbesRetirementIncomeSolutionLivingAnnuity: 'GAFLAI01',
    ManagedLivingAnnuity: 'GAFLAM01',
    TheLivingAnnuity: 'GAFLAN01',
    AlexanderForbesRetirementIncomeSolutionPreservationPensionFund: 'GAFPPE01',
    ThePreservationPensionFund: 'GAFPPE02',
    AlexanderForbesRetirementIncomeSolutionPreservationProvidentFund: 'GAFPPR01',
    ThePreservationProvidentFund: 'GAFPPR02',
    AlexanderForbesRetirementIncomeSolutionRetirementAnnuity: 'GAFRAF01',
    TheRetirementAnnuityFund: 'GAFRAF02',
    AlexanderForbesRetirementIncomeSolutionEmployerRetirementAnnuity: 'GAFRAF03',
    EmployerRetirementAnnuity: 'GAFRAF04',
    WealthCreatorSinkingFundPolicy: 'GAFSNK01',
    AlexanderForbesTaxFreeSavingsAccount: 'GAFTFS01',
    SanlamFixedReturnPlan: 'SANFRP01',
    SanlamFixedReturnPlanWithIncome: 'SANFRP02',
    SanlamLifeAnnuity: 'SANLA01',
    SanlamTermAnnuity: 'SANTAP01'
} as const;
export type IAPPRODUCTCONFIGURATIONCODE = typeof IAPPRODUCTCONFIGURATIONCODE[keyof typeof IAPPRODUCTCONFIGURATIONCODE];


export function IAPPRODUCTCONFIGURATIONCODEFromJSON(json: any): IAPPRODUCTCONFIGURATIONCODE {
    return IAPPRODUCTCONFIGURATIONCODEFromJSONTyped(json, false);
}

export function IAPPRODUCTCONFIGURATIONCODEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPPRODUCTCONFIGURATIONCODE {
    return json as IAPPRODUCTCONFIGURATIONCODE;
}

export function IAPPRODUCTCONFIGURATIONCODEToJSON(value?: IAPPRODUCTCONFIGURATIONCODE | null): any {
    return value as any;
}

